import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "pricing-area ptb-100 bg-gondola" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = ["data-aos-delay"]
const _hoisted_5 = { class: "pricing-single-item style-two" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "amount" }
const _hoisted_8 = { class: "months" }
const _hoisted_9 = { class: "text-white mt-2" }
const _hoisted_10 = { class: "ps-0 list-unstyled pricing-list" }
const _hoisted_11 = { class: "col-lg-12 text-center mt-4 mt-lg-5" }
const _hoisted_12 = { class: "text-silver" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "section-title mw-860 m-auto text-center",
        "data-aos": "fade-up",
        "data-aos-duration": "1000",
        "data-aos-delay": "100"
      }, [
        _createElementVNode("span", { class: "top-title" }, "الباقات والأسعار"),
        _createElementVNode("h2", { class: "text-white" }, "اختر الباقة المناسبة لك")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pricingPlans, (plan, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["col-xl-4 col-md-6", { 'mt-4 mt-xl-0': index !== 0 }]),
            "data-aos": "fade-up",
            "data-aos-duration": "1000",
            "data-aos-delay": 100 * (index + 1)
          }, [
            _createElementVNode("div", _hoisted_5, [
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ignite d-block" }, " اشتراك IPTV مرن بدون تجديد تلقائي ", -1)),
              _createElementVNode("div", {
                class: "pricing-content bg-mg",
                style: _normalizeStyle({ backgroundImage: 'url(' + plan.bgImage + ')' })
              }, [
                _createElementVNode("img", {
                  src: plan.image,
                  alt: plan.name + ' pricing'
                }, null, 8, _hoisted_6),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(plan.name), 1),
                  _createElementVNode("h2", null, _toDisplayString(plan.yearPrice) + "€", 1),
                  _cache[0] || (_cache[0] = _createElementVNode("span", { class: "renew" }, "سنة واحدة", -1)),
                  _createElementVNode("h3", _hoisted_9, _toDisplayString(plan.twoYearsPrice) + "€ / سنتين", 1)
                ]),
                _createElementVNode("ul", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.features, (feature, i) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: i,
                      class: "d-flex justify-content-between align-items-center"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(feature.name), 1),
                      _createElementVNode("i", {
                        class: _normalizeClass(["ti ti-circle-check", { 'opacity-25': !feature.included }])
                      }, null, 2)
                    ]))
                  }), 128))
                ]),
                _createVNode(_component_RouterLink, {
                  to: "/contact-us",
                  class: "btn active"
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("span", { class: "border-style" }, "اشترك الآن", -1)
                  ]))]),
                  _: 1
                })
              ], 4)
            ])
          ], 10, _hoisted_4))
        }), 128)),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", _hoisted_12, [
            _cache[4] || (_cache[4] = _createTextVNode(" للمساعدة في اختيار الباقة المناسبة أو تفعيل الاشتراك، تواصل معنا في أي وقت. ", -1)),
            _createVNode(_component_RouterLink, {
              to: "/contact-us",
              class: "read-more style-two text-grey-teal"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" تواصل معنا ", -1),
                _createElementVNode("i", { class: "ti ti-arrow-right" }, null, -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}